export interface CCTVVideoRequest {
  id: string;
  lockerCode: string;
  status: any;
  requestDate: string;
  startDate: string;
  endDate: string;
}

export enum VideoRequestStatus {
  Pending = 1,
  DownloadedOnLocker = 2,
  Executed = 3,
  ExecutionFailed = 4,
  Expired = 5,
  Canceled = 6,
  NoVideosFound = 7,
}